module.exports = __webpack_public_path__ + "img/greatwall.4449aaf9.jpg";